var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nodata-pack"},[_c('i',{staticClass:"nodata-img"}),_c('span',{staticClass:"nodata-msg"},[_vm._v(_vm._s(_vm.value || _vm.$t('暂无数据')))])])}
var staticRenderFns = []

export { render, staticRenderFns }